export const MenuItems = [
    {
      title: 'New Events',
      path: '/new-events',
      cName: 'dropdown-link'
    },
    {
      title: 'Mentoring',
      path: '/mentoring',
      cName: 'dropdown-link'
    },
    {
      title: 'Student Orgs',
      path: '/student-orgs',
      cName: 'dropdown-link'
    }
  ];